import {Observable} from "rxjs";
import * as _ from 'lodash';
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private http: HttpClient) {
  }

  static blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string); // reader.result contiene il base64
      reader.onerror = reject;
      reader.readAsDataURL(blob); // converte il Blob in DataURL base64
    });
  }

  static concatBase64Type(extension: string, base64: string): string {
    return 'data:image/' + extension + ';base64,' + base64
  }

  static parseBase64DataUrlToExtension(dataUrl: string): { extension: string; base64: string } {
    if (!dataUrl.startsWith('data:')) {
      throw new Error('Invalid data URL');
    }

    const matches = dataUrl.match(/^data:image\/(\w+);base64,(.*)$/);
    if (!matches || matches.length !== 3) {
      throw new Error('Invalid base64 image data URL format');
    }

    const extension = matches[1]; // jpg, png, etc.
    const base64 = matches[2];

    return {extension, base64};
  }

  static base64ToFile(base64: string, filename: string, mimeType: string): File {
    const byteString = atob(base64.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new File([ab], filename, {type: mimeType});
  }

  urltoFile(url, filename, mimeType) {
    return (fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, {type: mimeType});
      })
    );
  }

  getBase64Image(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      },
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  resizeImageToFormat(file: File, targetWidth?: number, targetHeight?: number): Observable<{
    file: File;
    base64: string
  }> {
    return new Observable((observer) => {
      const originalSize = file.size;
      const img = new Image();

      img.src = URL.createObjectURL(file);

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // Resize solo se è sopra i 3000px
        if (width > 3000 || height > 3000) {
          const ratio = 2000 / Math.max(width, height); // es: riduci a max 2000px
          width = width * ratio;
          height = height * ratio;
        }

        // Se width/height specificati dall'utente, usa quelli
        if (targetWidth) width = targetWidth;
        if (targetHeight) height = targetHeight;

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Migliora la qualità minima se immagine sopra 1MB
        const quality = calcQuality(originalSize);

        const dataUrl = canvas.toDataURL(file.type, quality);

        // Converti in base64 e file
        this.getBase64Image(dataUrl, (base64) => {
          this.urltoFile(base64, 'resized-image', file.type).then((resizedFile) => {
            observer.next({
              file: resizedFile,
              base64: base64,
            });
            observer.complete();
          });
        });
      };

      function calcQuality(size: number): number {
        if (size <= 500 * 1024) return 0.8;         // < 500 KB → quasi nessuna compressione
        if (size <= 2 * 1024 * 1024) return 0.7;    // < 2 MB → buona qualità
        if (size <= 5 * 1024 * 1024) return 0.6;    // < 5 MB → media
        return 0.5;                                 // > 5 MB → compressione più forte, ma non esagerata
      }
    });
  }


}
